<template>
  <div>
    <div class="mb-3">
      <span>封面</span>
    </div>
    <ul>
      <li class="flex-start">
        <span>封面图片</span>
        <template v-if="!data.image">
          <el-button type="text" class="leading-22" @click="onUploadImage">上传图片</el-button>
        </template>
        <template v-else>
          <image-box :src="data.image" @remove="onRemove" />
        </template>
      </li>
      <li>
        <span>背景位置</span>
        <el-select class="short-box" size="mini-x" v-model="data.position" @change="onChangePosition">
          <el-option v-for="item in positionOptions" :key="item.value" :value="item.value" :label="item.label" />
        </el-select>
      </li>
    </ul>
  </div>
</template>

<script>
import ImageBox from '@/views/survey/edit/aside/appearance/ImageBox'
import { FileErrorCode, uploadFile } from '@dygc/shared'
import { uploadFile as uploadFile2End } from '@/api/file'

export default {
  name: 'PcCover',
  components: { ImageBox },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      positionOptions: [
        { label: '平铺', value: 'repeat' },
        { label: '居中', value: 'center' },
        { label: '拉伸', value: 'stretch' }
      ]
    }
  },
  methods: {
    onRemove() {
      this.data.image = ''
      this.$emit('change')
    },
    onChangePosition() {
      this.$emit('change')
    },
    onUploadImage() {
      const allowTypes = ['jpg', 'jpeg', 'png']
      uploadFile(5, allowTypes, { unit: 'MB' })
        .then(file => {
          let fd = new FormData()
          fd.append('file', file)
          uploadFile2End(fd).then(res => {
            if (!this.data.position) {
              this.data.position = 'center'
            }
            this.data.image = res.data.data.url
            this.$emit('change')
          })
        })
        .catch(err => {
          if (err.code === FileErrorCode.NO_ALLOW_TYPE) {
            this.$message.warning(`仅支持上传${allowTypes.join('、')}格式的图片`)
          } else {
            this.$message.warning(err.msg)
          }
        })
    }
  }
}
</script>
